// extracted by mini-css-extract-plugin
export var numpadContainer = "_kh-1";
export var phoneButton = "_kh-0";